import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Directive({
  selector: '[ngModel][nbDebounce]',
})
export class NbDebounceDirective implements OnInit, OnDestroy {
  @Output()
  public nbDebounce = new EventEmitter<any>();

  @Input()
  public debounceTime = 300;

  private isFirstChange = true;

  private subscription: Subscription;

  constructor(public model: NgControl) {}

  ngOnInit() {
    this.subscription = this.model.valueChanges
      .pipe(debounceTime(this.debounceTime), distinctUntilChanged())
      .subscribe(modelValue => {
        if (this.isFirstChange) {
          this.isFirstChange = false;
        } else {
          this.nbDebounce.emit(modelValue);
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
